"use strict";

exports.__esModule = true;
exports.ServicesPreferencesModalStep = exports.FormatterKey = exports.AsyncComponentDataStatus = void 0;
let AsyncComponentDataStatus = exports.AsyncComponentDataStatus = /*#__PURE__*/function (AsyncComponentDataStatus) {
  AsyncComponentDataStatus["LOADING"] = "loading";
  AsyncComponentDataStatus["ERROR"] = "error";
  AsyncComponentDataStatus["IDLE"] = "idle";
  return AsyncComponentDataStatus;
}({});
let FormatterKey = exports.FormatterKey = /*#__PURE__*/function (FormatterKey) {
  FormatterKey["DELETE_SERVICE_BUTTON_ARIA_LABEL"] = "DELETE_SERVICE_BUTTON_ARIA_LABEL";
  FormatterKey["DELETE_SERVICE_BUTTON_TEXT"] = "DELETE_SERVICE_BUTTON_TEXT";
  FormatterKey["EDIT_SERVICE_BUTTON_ARIA_LABEL"] = "EDIT_SERVICE_BUTTON_ARIA_LABEL";
  FormatterKey["EDIT_SERVICE_BUTTON_TEXT"] = "EDIT_SERVICE_BUTTON_TEXT";
  FormatterKey["HOUR_UNIT"] = "HOUR_UNIT";
  FormatterKey["MINUTE_UNIT"] = "MINUTE_UNIT";
  FormatterKey["NEXT_BUTTON"] = "NEXT_BUTTON";
  FormatterKey["BACK_BUTTON"] = "BACK_BUTTON";
  FormatterKey["SUBMIT_BUTTON"] = "SUBMIT_BUTTON";
  FormatterKey["SAVE_BUTTON"] = "SAVE_BUTTON";
  FormatterKey["SELECT_STAFF_LABEL"] = "SELECT_STAFF_LABEL";
  FormatterKey["SELECT_LOCATION_LABEL"] = "SELECT_LOCATION_LABEL";
  FormatterKey["ADD_ANOTHER_SERVICE_BUTTON"] = "ADD_ANOTHER_SERVICE_BUTTON";
  FormatterKey["ADD_ANOTHER_SERVICE_DESCRIPTION"] = "ADD_ANOTHER_SERVICE_DESCRIPTION";
  FormatterKey["PRICE_RANGE"] = "PRICE_RANGE";
  FormatterKey["NUMBER_OF_SERVICES"] = "NUMBER_OF_SERVICES";
  FormatterKey["SELECTED_STAFF"] = "SELECTED_STAFF";
  FormatterKey["CONFIRMATION_STEP_TITLE"] = "CONFIRMATION_STEP_TITLE";
  FormatterKey["CONFIRMATION_STEP_TEXT"] = "CONFIRMATION_STEP_TEXT";
  FormatterKey["CONFIRMATION_STEP_LEAVE_BUTTON"] = "CONFIRMATION_STEP_LEAVE_BUTTON";
  FormatterKey["CONFIRMATION_STEP_STAY_BUTTON"] = "CONFIRMATION_STEP_STAY_BUTTON";
  FormatterKey["LOADING_TEXT"] = "SELECT_STAFF_PLACEHOLDER";
  FormatterKey["SELECT_ANY_STAFF"] = "SELECT_ANY_STAFF";
  FormatterKey["SELECT_ANY_STAFF_SUBTITLE"] = "SELECT_ANY_STAFF_SUBTITLE";
  FormatterKey["SUMMARY_ANY_STAFF"] = "SUMMARY_ANY_STAFF";
  FormatterKey["SELECT_CUSTOM_PREFERENCE_PLACEHOLDER"] = "SELECT_CUSTOM_PREFERENCE_PLACEHOLDER";
  FormatterKey["SELECT_CUSTOM_PREFERENCE_ERROR"] = "SELECT_CUSTOM_PREFERENCE_ERROR";
  FormatterKey["SERVICE_PREFERENCES"] = "SERVICE_PREFERENCES";
  FormatterKey["CLOSE_MODAL_BUTTON_ARIA_LABEL"] = "CLOSE_MODAL_BUTTON_ARIA_LABEL";
  FormatterKey["CLOSE_CONFIRMATION_MODAL_BUTTON_ARIA_LABEL"] = "CLOSE_CONFIRMATION_MODAL_BUTTON_ARIA_LABEL";
  FormatterKey["SERVICE_PREFERENCES_TITLE"] = "SERVICE_PREFERENCES_TITLE";
  FormatterKey["ERROR_FETCHING_DATA"] = "ERROR_FETCHING_DATA";
  FormatterKey["PREFERENCES_STEP_TITLE"] = "PREFERENCES_STEP_TITLE";
  FormatterKey["BASKET_STEP_TITLE"] = "BASKET_STEP_TITLE";
  FormatterKey["SERVICE_SELECTION_STEP_TITLE"] = "SERVICE_SELECTION_STEP_TITLE";
  FormatterKey["LOCATION_STEP_TITLE"] = "LOCATION_STEP_TITLE";
  FormatterKey["STAFF_MEMBER_STEP_TITLE"] = "STAFF_MEMBER_STEP_TITLE";
  FormatterKey["PAYMENT_PRICING_PLAN_DESCRIPTION"] = "PAYMENT_PRICING_PLAN_DESCRIPTION";
  FormatterKey["CAPITALIZED_PAYMENT_PRICING_PLAN_DESCRIPTION"] = "CAPITALIZED_PAYMENT_PRICING_PLAN_DESCRIPTION";
  FormatterKey["PAYMENTS_SEPARATOR"] = "PAYMENTS_SEPARATOR";
  FormatterKey["SEARCH_PLACEHOLDER"] = "SEARCH_PLACEHOLDER";
  FormatterKey["NO_SEARCH_RESULTS_TITLE"] = "NO_SEARCH_RESULTS_TITLE";
  FormatterKey["NO_SEARCH_RESULTS_SUBTITLE"] = "NO_SEARCH_RESULTS_SUBTITLE";
  FormatterKey["DEFAULT_DURATION_LABEL"] = "DEFAULT_DURATION_LABEL";
  FormatterKey["DURATION_RANGE"] = "DURATION_RANGE";
  FormatterKey["SELECT_UP_TO_X_ITEMS"] = "SELECT_UP_TO_X_ITEMS";
  FormatterKey["ADDON_DURATION_MIN"] = "ADDON_DURATION_MIN";
  FormatterKey["ADD_ONS_SECTION_TITLE"] = "ADD_ONS_SECTION_TITLE";
  FormatterKey["SELECT_ADD_ONS_TITLE"] = "SELECT_ADD_ONS_TITLE";
  FormatterKey["SELECT_VARIANT_TITLE"] = "SELECT_VARIANT_TITLE";
  FormatterKey["DURATION"] = "DURATION";
  FormatterKey["ADD_ONS_COUNT"] = "ADD_ONS_COUNT";
  FormatterKey["PREFERENCES_SECTION_TITLE"] = "PREFERENCES_SECTION_TITLE";
  FormatterKey["WITH_STAFF_PREFIX"] = "WITH_STAFF_PREFIX";
  FormatterKey["DISCOUNT_CALCULATED_AT_CHECKOUT"] = "DISCOUNT_CALCULATED_AT_CHECKOUT";
  return FormatterKey;
}({});
let ServicesPreferencesModalStep = exports.ServicesPreferencesModalStep = /*#__PURE__*/function (ServicesPreferencesModalStep) {
  ServicesPreferencesModalStep["LOCATION"] = "LOCATION";
  ServicesPreferencesModalStep["STAFF_MEMBER"] = "STAFF_MEMBER";
  ServicesPreferencesModalStep["EDIT_STAFF_MEMBER"] = "EDIT_STAFF_MEMBER";
  ServicesPreferencesModalStep["PREFERENCES"] = "PREFERENCES";
  ServicesPreferencesModalStep["BASKET"] = "BASKET";
  ServicesPreferencesModalStep["CALENDAR"] = "CALENDAR";
  ServicesPreferencesModalStep["SERVICE_SELECTION"] = "SERVICE_SELECTION";
  ServicesPreferencesModalStep["UNKNOWN"] = "UNKNOWN";
  ServicesPreferencesModalStep["DYNAMIC_PREFERENCES"] = "DYNAMIC_PREFERENCES";
  ServicesPreferencesModalStep["ADD_ONS"] = "ADD_ONS";
  ServicesPreferencesModalStep["DYNAMIC_AND_ADD_ONS"] = "DYNAMIC_AND_ADD_ONS";
  return ServicesPreferencesModalStep;
}({});
//# sourceMappingURL=types.js.map